import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalFooter,
  styled,
} from '@teko/ds-desktop';
import ThankForRatingImg from 'assets/thank-for-rating.svg';
import { t } from 'i18n';
import { useEffect, useRef, useState } from 'react';

interface IRatingSuccessModalProps {
  show: boolean;
  onClose: () => void;
}

const DURATION = 5;

export const RatingSuccessModal: React.FC<IRatingSuccessModalProps> = ({
  show,
  onClose,
}) => {
  const [, setSecondsLeft] = useState(DURATION); // auto close modal after 5s
  const [running, setRunning] = useState(true);
  const timerRef = useRef<ReturnType<typeof setInterval> | undefined>();

  // Reset when modal opens/closes or duration changes
  useEffect(() => {
    if (show) {
      setSecondsLeft(DURATION);
      setRunning(true);
    } else {
      setRunning(false);
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [show]);

  // Start / stop interval
  useEffect(() => {
    clearInterval(timerRef.current);
    if (!show) return;
    if (!running) return;

    timerRef.current = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          // time's up: close modal
          clearInterval(timerRef.current);
          // call onClose on the next tick so UI updates cleanly
          onClose();
          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [running, show, onClose]);

  return (
    <Modal
      visible={show}
      borderRadius="l"
      width={446}
      contentStyle={{ padding: 0 }}
      okText=""
      cancelText=""
      showCloseIcon={false}
      footer={null}
    >
      <ModalBody
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <ImageWrapper>
          <Image src={ThankForRatingImg} objectFit="cover" />
        </ImageWrapper>
        <Text>{t('Cảm ơn bạn đã đánh giá!')}</Text>
      </ModalBody>
      <ModalFooter>
        <Button
          width={'100%'}
          variant="primary"
          borderRadius="m"
          onClick={() => {
            onClose();
            setRunning(false);
            clearInterval(timerRef.current);
          }}
        >
          {t('Đóng')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const ImageWrapper = styled.div`
  width: 64px;
  height: 64px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`;
